<header class="d-flex justify-content-center align-items-center" style="background-color: white !important;">
    <div class="container">
        <div class="row d-flex justify-content-center align-items-center">
            <div class="col-md-12 text-center">
                <svg-icon src="assets/svg/amigo-logo.svg" [svgClass]="'amigo-logo'"></svg-icon>
            </div>
        </div>
    </div>
</header>
